import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AiCreatePostModalService } from '@features/posts/services/ai-create-post-modal.service';

@Component({
  selector: 'app-step-choice',
  standalone: true,
  templateUrl: './step-choice.component.html',
  styleUrl: './step-choice.component.scss',
})
export class StepChoiceComponent {
  protected readonly service = inject(AiCreatePostModalService);
  private readonly router = inject(Router);

  onManualCreate() {
    this.service.closeModal();
    this.router.navigate(['/create']);
  }
}
